<div class="offcanvas-header">
	<div class="left">
		<h3 class="offcanvas-title">Scheduled Items</h3>
	</div>
	<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<hr class="mx-3" />
<div class="offcanvas-body">
	<div class="body">
		<div *ngIf="!readonlyView" class="action-buttons">
			<button (click)="openScheduler()" class="btn btn-primary w-100" type="button">Open Scheduler</button>
			<button (click)="addCallAssessment()" class="btn btn-primary w-100" type="button">Schedule Call</button>
			<button (click)="addOnSiteAssessment()" class="btn btn-primary w-100" type="button">Schedule On Site</button>
		</div>

		<ng-container *ngIf="scheduledItems.length; else noScheduledItems">
			<app-accordion parentId="scheduledItems">
				<ng-container *ngFor="let item of scheduledItems; let i = index">
					<div class="d-flex flex-row justify-content-between w-100">
						<div class="w-100">
							<app-accordion-item
								parentId="scheduledItems"
								[itemId]="i.toString()"
								(toggleEvent)="openScheduledItemsListItemModal(item, i)"
								[disableExpand]="true"
								[lineHeight]="26"
							>
								<div header class="w-100">
									<app-scheduled-item-title
										[index]="i"
										[item]="item"
										[readonlyView]="readonlyView"
										[mobile]="true"
									></app-scheduled-item-title>
								</div>
								<div actions>
									<app-scheduled-item-actions
										[item]="item"
										[readonlyView]="readonlyView"
										[mobile]="true"
										(cancelAssessment)="cancelAssessment($event)"
										(removeAssessment)="removeAssessment($event)"
									></app-scheduled-item-actions>
								</div>
							</app-accordion-item>
						</div>
					</div>
				</ng-container>
			</app-accordion>
		</ng-container>
		<ng-template #noScheduledItems>
			<em class="small-text">No assessments have been scheduled.</em>
		</ng-template>
	</div>
</div>
